import { TInteropMapping } from './interop-mapping.type'

export type InteropLogError = {
  type: 'MEDEVENT' | 'PATIENT'
  remoteId?: string
  error: string
}

export type InteropPatient = {
  remoteId: string
  firstname?: string
  lastname?: string
  phone?: string
  mail?: string
  birthdate?: string | Date
  locale?: string
  gender?: string
  isArchived?: boolean
  interopMetadata?: Record<string, any>
}

export type InteropConsultation = {
  remoteId?: string
  prettyName?: string
  code?: string
  date: Date
  [key: string]: any
}

export type TInteropLogPayloadEvent =
  | 'PATIENT_ADMITTED'
  | 'PATIENT_TRANSFERRED'
  | 'PATIENT_DISCHARGED'
  | 'PATIENT_REGISTERED'
  | 'PATIENT_PRE_ADMITTED'
  | 'PATIENT_CONSULTATION_UPDATED'
  | 'PATIENT_CONSULTATION_CANCELLED'

export type TInteropPatientVisit = {
  number: string
  assigningAuthority?: string | string[]
  numberType?: string
  admissionTime?: Date
  dischargeTime?: Date
  patientClass?: string
  admissionType?: string
  ufMedId?: string
  ufCareId?: string
  [key: string]: any
}

export type TInteropEventAuthor = {
  id: string
  lastname?: string
  firstname?: string
}

export type InteropLogPayload = {
  patient: InteropPatient

  timestamp?: Date
  messageId?: string
  messageType?: string
  event?: TInteropLogPayloadEvent
  eventAuthor?: TInteropEventAuthor

  visit?: TInteropPatientVisit
  preAdmission?: TInteropPatientVisit

  /**
   * This property replaces previous `consultations` array. Using a single
   * consultation element per interopLog allows the interop-engine to tag
   * the InteropLog with debug information like the ID of InteropMapping used and
   * the ID of PatientMedEvent created/updated using the log+mapping
   */
  consultation?: InteropConsultation

  /**
   * @deprecated please use one `consultation` per interopLog instead
   */
  consultations?: InteropConsultation[]

  consultationsToRemove?: string[]
}

export type TPatientInteropLog = {
  id: number
  ProjectId: number
  PatientId?: number
  payload?: InteropLogPayload
  origin?: string
  errors?: InteropLogError[]
  s3filename?: string
  PatientMedEventId: number
  PatientFollowupId: number
  InteropMappingId: number
  InteropMapping: TInteropMapping
  processedAt: Date
  createdAt: Date
  isHydrated: boolean
  CompositeFromInteropLogId: number
  isLatest?: boolean
  remoteType?: string
  remoteId?: string
  duplicateCount?: number
}

export enum EInteropLogSortOrder {
  DEFAULT = 'DEFAULT',
  RECEPTION = 'RECEPTION',
  EMISSION = 'EMISSION',
}
